import React, { useEffect } from 'react'
import { ThemeColors, ThemeColorType } from '@evrekadev/evreka-ui-components'
import { Polyline, PolylineProps, Tooltip } from 'react-leaflet'
import { useMapContext } from 'components/MapV2/MapProvider'
import * as L from 'leaflet'
import 'leaflet-kml'

export type KmlLayerItem = {
  name?: string
  url: string
  color?: keyof ThemeColorType
  opacity?: number
}

type KmlLayerProps = {
  kmls: Array<KmlLayerItem>
  noTooltip?: boolean
}

export const KML_POLYLINE_COLORS: Array<keyof ThemeColorType> = [
  'orange500',
  'green500',
  'blue500',
  'pink500',
  'yellow500',
  'purple500',
  'red500',
]

export type KMLLayerType = PolylineProps & { name?: string }

const getKmlLayer = async (kml: KmlLayerItem) => {
  const response = await fetch(kml.url)
  const kmltext = await response.text()
  const parser = new DOMParser()
  const parsedKML = parser.parseFromString(kmltext, 'text/xml')
  const kmlLatLngs = new L.KML(parsedKML) as {
    latLngs: L.LatLng[]
  }

  const kmlPolyline: KMLLayerType = {
    positions: kmlLatLngs.latLngs,
    color: kml.color ? ThemeColors[kml.color] : undefined,
    opacity: kml.opacity,
    name: kml.name,
  }

  return kmlPolyline
}

export const KmlLayer: React.FC<React.PropsWithChildren<KmlLayerProps>> = ({
  noTooltip = false,
}) => {
  const { setParsedKmls, parsedKmls, kmls } = useMapContext()

  useEffect(() => {
    if (kmls?.length === 0) {
      setParsedKmls?.([])
      return
    }

    kmls?.forEach((kml) => {
      getKmlLayer(kml).then((kmlLayer) => {
        setParsedKmls?.((prevLayers) => [...prevLayers, kmlLayer])
      })
    })
  }, [kmls])

  return parsedKmls?.map((layer, index) => (
    <Polyline key={index} {...layer}>
      {!noTooltip && layer.name && <Tooltip>{layer.name}</Tooltip>}
    </Polyline>
  ))
}
